import { useInView } from 'react-intersection-observer';

//components
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';
import { PillLink } from '@/containers-ai/Buttons';

//styles
import {
  AIGrid,
  CtaRow,
  Panel,
  ClimbHeading,
  Bars,
  Bar,
  QuarterRow,
  Quarter,
  ClimbFooter,
} from './AICompounding.styles';
import { Container } from '@/components/Grid';

const BAR_HEIGHTS = ['46%', '64%', '82%', '98%'];

export function AICompounding({ content }) {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true });
  const bars = content.chart.quarters.map((quarter, index) => ({
    quarter,
    height: BAR_HEIGHTS[index],
  }));

  return (
    <Section id="ai">
      <Container>
        <AIGrid>
          <div>
            <Kicker>
              <KickerDot />
              {content.kicker}
            </Kicker>
            <SectionTitle style={{ maxWidth: '565px' }}>
              {content.title}
              <Grad>{content.titleHighlight}</Grad>
            </SectionTitle>
            <SectionLede>{content.lede}</SectionLede>
            <CtaRow>
              <PillLink href={content.ctaHref ?? '/ai/'} className="qlf-btn-8">
                {content.ctaLabel}
              </PillLink>
            </CtaRow>
          </div>

          <Panel ref={ref}>
            <ClimbHeading>{content.chart.heading}</ClimbHeading>
            <Bars>
              {bars.map((bar) => (
                <Bar key={bar.quarter} $on={inView} $height={bar.height} />
              ))}
            </Bars>
            <QuarterRow>
              {bars.map((bar) => (
                <Quarter key={bar.quarter}>{bar.quarter}</Quarter>
              ))}
            </QuarterRow>
            <ClimbFooter>
              <span>{content.chart.footerLow}</span>
              <Grad style={{ fontSize: '16px' }}>
                {content.chart.footerHigh}
              </Grad>
            </ClimbFooter>
          </Panel>
        </AIGrid>
      </Container>
    </Section>
  );
}
